"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useShift", {
    enumerable: true,
    get: function() {
        return useShift;
    }
});
const _react = require("react");
const useShift = function() {
    let activate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    const [shiftHeld, setShiftHeld] = (0, _react.useState)(false);
    const downHandler = (0, _react.useCallback)((ev)=>{
        if (ev.key === "Shift") {
            setShiftHeld(true);
        }
    }, []);
    const upHandler = (0, _react.useCallback)((ev)=>{
        if (ev.key === "Shift") {
            setShiftHeld(false);
        }
    }, []);
    (0, _react.useEffect)(()=>{
        if (!activate) {
            return undefined;
        }
        window.addEventListener("keydown", downHandler);
        window.addEventListener("keyup", upHandler);
        return ()=>{
            window.removeEventListener("keydown", downHandler);
            window.removeEventListener("keyup", upHandler);
        };
    }, [
        activate,
        downHandler,
        upHandler
    ]);
    return {
        shiftHeld
    };
};

//# sourceMappingURL=useShift.js.map